export const SET_USER = 'SET_USER';
export const SET_PERMISSIONS = 'SET_PERMISSIONS';
export const CLEAN_USER = 'CLEAN_USER';
export const BLOCK_USER = 'BLOCK_USER';

export const defaultUserState = {
  user: null,
  impersonated: false,
  actions: [],
  pages: [],
  blocked: false,
};

class BlockedUser {
  constructor({ id, name }) {
    this.isBlocked = true;
    this.id = id;
    this.name = name;
  }
}

export const userReducer = (state, action) => {
  switch (action.type) {
    case SET_USER:
      const user = action.payload;
      return {
        ...state,
        user,
        impersonated: user?.impersonatedBy !== undefined,
      };

    case SET_PERMISSIONS: {
      const { pages, actions } = action.payload;

      return {
        ...state,
        user: state.user || {},
        pages,
        actions,
      };
    }

    case BLOCK_USER: {
      return {
        ...defaultUserState,
        user: new BlockedUser(action.payload),
        blocked: true,
      };
    }

    case CLEAN_USER:
      return {
        ...defaultUserState,
      };

    default: {
      return state;
    }
  }
};

export default userReducer;
